import $ from 'jquery';

export default () => {
	$('<input />', {
		id: 'unfocus-unselect-hidden-field',
		value: '',
		style: 'position:fixed;top:0;left:0;background:transparent;border:0;outline:0;height:0;width:0;',
	})
		.appendTo('body')
		.focus()
		.select()
		.remove();
};
